/** Host-page theme tokens (--fp-vob-*) for embed styling. */
export const WEBFORM_STYLES = `
:host {
  display: block;
}

.webform-element {
  font-family: var(
    --fp-vob-font-family,
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    Oxygen,
    Ubuntu,
    Cantarell,
    "Fira Sans",
    "Droid Sans",
    "Helvetica Neue",
    sans-serif
  );
  font-size: var(--fp-vob-font-size, 1rem);
  line-height: var(--fp-vob-line-height, 1.4);
  word-wrap: break-word;
  color: var(--fp-vob-text-color, #363636);
  background: var(--fp-vob-background-color, #fff);
  border: var(--fp-vob-element-border, 1px solid var(--fp-vob-element-border-color, #fff));
  border-radius: var(--fp-vob-element-border-radius, 5px);
  text-rendering: optimizeLegibility;
  padding: var(--fp-vob-element-padding, 20px);
  position: relative;
  box-sizing: border-box;
}

.form-item {
  margin-bottom: var(--fp-vob-field-gap, 15px);
}

.form-item label,
.autocomplete label {
  display: block;
  font-family: var(--fp-vob-label-font-family, inherit);
  font-size: var(--fp-vob-label-font-size, 12px);
  font-weight: var(--fp-vob-label-font-weight, normal);
  letter-spacing: var(--fp-vob-label-letter-spacing, normal);
  line-height: var(--fp-vob-label-line-height, normal);
  color: var(--fp-vob-label-color, inherit);
  opacity: var(--fp-vob-label-opacity, 0.8);
  margin-bottom: var(--fp-vob-label-margin-bottom, 5px);
}

.form-item label .required {
  color: var(--fp-vob-required-color, red);
}

.form-item input,
.form-item textarea,
.form-item select,
.autocomplete input {
  box-sizing: border-box;
  transition: background-color 0.1s linear, border-color 0.1s linear,
    color 0.1s linear, box-shadow 0.1s linear;
  color: var(--fp-vob-input-color, #000);
  background-color: var(--fp-vob-input-background-color, #fff);
  font-family: var(--fp-vob-input-font-family, inherit);
  font-size: var(--fp-vob-input-font-size, inherit);
  font-weight: var(--fp-vob-input-font-weight, normal);
  letter-spacing: var(--fp-vob-input-letter-spacing, normal);
  line-height: var(--fp-vob-input-line-height, normal);
  padding: var(--fp-vob-input-padding, 15px);
  border: var(--fp-vob-input-border, 1px solid #ddd);
  border-radius: var(--fp-vob-input-border-radius, 6px);
  outline: none;
  width: var(--fp-vob-input-width, calc(100% - 32px));
  min-height: var(--fp-vob-input-min-height, auto);
  height: var(--fp-vob-input-height, auto);
  -webkit-appearance: none;
}

.form-item textarea {
  height: var(--fp-vob-textarea-height, auto);
  min-height: var(--fp-vob-textarea-min-height, auto);
  padding-top: var(--fp-vob-textarea-padding-top, var(--fp-vob-input-padding, 15px));
}

.form-item input::placeholder,
.form-item textarea::placeholder,
.autocomplete input::placeholder {
  color: var(--fp-vob-input-placeholder, #949494);
  font-family: var(--fp-vob-input-font-family, inherit);
  font-size: var(--fp-vob-input-font-size, inherit);
  font-weight: var(--fp-vob-input-font-weight, normal);
  letter-spacing: var(--fp-vob-input-letter-spacing, normal);
  opacity: 1;
}

.form-item input:focus,
.form-item textarea:focus,
.autocomplete input:focus {
  border: var(
    --fp-vob-input-focus-border,
    1px solid var(--fp-vob-primary-color, #f5650f)
  );
  box-shadow: var(--fp-vob-input-focus-box-shadow, 0 0 3px 0 var(--fp-vob-primary-color, #f5650f));
}

button,
.button {
  border: 1px solid
    var(--fp-vob-button-border-color, var(--fp-vob-primary-color, #f5650f));
  background: var(--fp-vob-button-background, var(--fp-vob-primary-color, #f5650f));
  padding: var(--fp-vob-button-padding, 15px);
  color: var(--fp-vob-button-color, #fff);
  border-radius: var(--fp-vob-button-border-radius, 6px);
  font-family: var(--fp-vob-button-font-family, inherit);
  font-size: var(--fp-vob-button-font-size, inherit);
  font-weight: var(--fp-vob-button-font-weight, normal);
  letter-spacing: var(--fp-vob-button-letter-spacing, normal);
  min-width: var(--fp-vob-button-min-width, auto);
  width: var(--fp-vob-button-width, 100%);
  outline: none;
  cursor: pointer;
  transition: color 0.2s ease-in-out, background-color 0.2s ease-in-out,
    border-color 0.2s ease-in-out;
}

button:hover,
.button:hover {
  filter: none;
  background: var(
    --fp-vob-button-hover-background,
    var(--fp-vob-primary-color, #f5650f)
  );
  border-color: var(
    --fp-vob-button-hover-border-color,
    var(
      --fp-vob-button-hover-background,
      var(--fp-vob-primary-color, #f5650f)
    )
  );
}

.form-error-banner {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
  padding: 12px 14px;
  border: 1px solid #e57373;
  border-radius: 4px;
  background: #ffebee;
  color: #b71c1c;
}

.form-error-message {
  flex: 1;
  margin: 0;
  font-size: 14px;
  line-height: 1.45;
}

.form-error-dismiss {
  flex-shrink: 0;
  border: none;
  background: transparent;
  color: #b71c1c;
  font-size: 22px;
  line-height: 1;
  padding: 0 4px;
  cursor: pointer;
}

.form-error-dismiss:hover {
  filter: none;
  opacity: 0.75;
}

.result.result-success {
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  background: white;
  left: 0;
  z-index: 2;
}

.result.result-success .result-body {
  transform: translate(-50%, -50%);
  position: absolute;
  top: 50%;
  text-align: center;
  width: 100%;
  left: 50%;
}

.result.result-success .result-body svg {
  height: 50px;
  width: 50px;
  opacity: 0.4;
  margin-bottom: 10px;
}

.result.result-success .result-body .success svg {
  fill: green;
}

.result.result-success .message.success {
  color: green;
}

.autocomplete {
  position: relative;
}

.autocomplete .results {
  position: absolute;
  background: white;
  max-height: 400px;
  overflow-y: auto;
  width: 100%;
  padding: 0;
  box-shadow: 0 2px 4px rgba(2, 8, 20, 0.1), 0 1px 2px rgba(2, 8, 20, 0.08);
  border: 1px solid #d1d4db;
  border-radius: 5px;
  margin-top: 5px;
  display: none;
  z-index: 5;
}

.autocomplete .results.visible {
  display: block;
}

.autocomplete .results ul {
  margin: 0;
  padding: 0;
}

.autocomplete .results ul li {
  list-style: none;
  padding: 20px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
}

.autocomplete .results ul li:hover {
  background: #fbfbfb;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.85);
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-overlay .spinner {
  border: 10px solid var(--fp-vob-background-color, #fff);
  border-top: 10px solid var(--fp-vob-primary-color, #f5650f);
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: fp-vob-spin 1s linear infinite;
}

@keyframes fp-vob-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
`;
